import styled from 'styled-components';
import _ from 'lodash'
import { ErrorMessage, ErrorMessageType } from '~/component/common/ErrorMessage';
import Switch from '@mui/material/Switch';
import { useFormikContext } from 'formik';
import { Option } from '~/const/enums';

const Required = styled.span`
  margin-left: 8px;
  font-size: 12px;
  color: red;
`;

const FormFieldContainer = styled.dl`
  margin: 4px 16px 8px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
`;
const FormLabel = styled.dt`
  padding: 0;
  width: 195px;
  min-width: 195px;
  font-size: 13px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
const FormLabelText = styled.span`
  flex-grow: 1;
  max-width: 130px;
`;
const FormValue = styled.dd`
  margin: 0;
  flex-grow: 1;
`;

interface FormFieldProps {
  name?: string
  items?: Option<string>[];
  isAllSelected?: boolean;
  objectName?: string
  label?: string;
  placeholder?: string;
  children: any;
  errorMessage?: ErrorMessageType;
  warningMessage?: string;
  required?: boolean;
  isToggleContents?: boolean;
  disabled?: boolean;
  isActive?: boolean;
  isTargeting?: boolean;
  toggleOnChange?: (value: boolean) => void;
}

// type FormFieldType = <T extends object>(
//   props: FormFieldProps<T>
// ) => React.ReactElement<FormFieldProps<T>>;

export const FormField: React.FC<FormFieldProps> = (props) => {
  const { setFieldValue, values } = useFormikContext();

  const isToggleContentsAndValue: boolean =
    _.isUndefined(props.isToggleContents) ||
    (props.isToggleContents && (props.isActive || !!_.get(values, `${props.name}.isActive`)));

  const toggle = (value: boolean) => {
    if(props.isTargeting) {
      setFieldValue(
        `${props.name}`,
        value ? {} : undefined
      );
    }
    if (props.name) {
      setFieldValue(`${props.name}.isActive`, value);
    }
    if (props.toggleOnChange) {
      props.toggleOnChange(value)
    }
  };

  return (
    <FormFieldContainer>
      <FormLabel>
        <FormLabelText>
          {props.label}
          {props.required && <Required>※</Required>}
        </FormLabelText>
        
        {props.isToggleContents && (
          <Switch
            color="primary"
            checked={isToggleContentsAndValue}
            onChange={(e, value) => toggle(value)}
            disabled={props.disabled}
          />
        )}
        {props.errorMessage && <ErrorMessage message={props.errorMessage} />}
        {props.warningMessage && <ErrorMessage message={props.warningMessage} />}
      </FormLabel>
      <FormValue>
        {props.children}
      </FormValue>
    </FormFieldContainer>
  );
};

export default FormField